import { FilterGroup } from '@customer/filters/types';
import InsightsCardGI from '@customer/components/data-display/insights-card-gi/InsightsCardGI';
import { useAppSelector } from '@customer/store/hooks';
import useFilters from '@customer/filters/useFilters';
import { useGetInteractionsSummaryQuery } from '@customer/store/apis/interactionsApi';
import { AssetListScenarios, PerformanceGIAssetsFilters } from '@customer/store/apis/assetsApi';
import { useLocationFilterParams } from '@customer/store/slices/locationFilterSlice';
import { usePerformanceTimeRangeFilters } from '@customer/store/slices/globalSlice';

const scenario = AssetListScenarios.PerformanceGeofenceInteractions;
const filterGroup = FilterGroup.PerformanceGI;

export function GeofenceInteractionsOverview() {
  const siteId = useAppSelector(state => state.auth.siteId);

  const timeRangeFilters = usePerformanceTimeRangeFilters();

  const filters = useFilters<PerformanceGIAssetsFilters>(filterGroup);

  const locationFilters = useLocationFilterParams({ filterGroup });

  const { currentData: interactionsSummaryData } = useGetInteractionsSummaryQuery(
    {
      query: {
        ...filters,
        ...locationFilters,
        ...timeRangeFilters,
        scenario,
      },
    },
    {
      refetchOnMountOrArgChange: 60,
      skip: typeof siteId === 'undefined',
    },
  );

  return <InsightsCardGI records={interactionsSummaryData?.gi} />;
}

export default GeofenceInteractionsOverview;
